import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6087dce2")

_pushScopeId("data-v-6087dce2")
const _hoisted_1 = {
  key: 0,
  class: "card horizontal",
  style: {"max-width":"400px","margin":"40px auto"}
}
const _hoisted_2 = {
  class: "card-image",
  style: {"margin-top":"25px","margin-left":"10px"}
}
const _hoisted_3 = { class: "card-stacked" }
const _hoisted_4 = { class: "card-content" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" name: ")
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("email:")
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("uid: ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode()
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("provider: ")
const _hoisted_13 = { class: "teal-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.user)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("img", {
            src: _ctx.user.photoURL,
            style: {"width":"75px","height":"75px","border-radius":"50%","border":"4px solid #333"}
          }, null, 8, ["src"])
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("p", null, [
              _hoisted_5,
              _createVNode("strong", null, _toDisplayString(_ctx.user.displayName), 1),
              _hoisted_6,
              _hoisted_7,
              _createVNode("strong", null, _toDisplayString(_ctx.user.email), 1),
              _hoisted_8,
              _hoisted_9,
              _createVNode("strong", null, _toDisplayString(_ctx.user.uid), 1),
              _hoisted_10,
              _hoisted_11,
              _hoisted_12,
              _createVNode("strong", _hoisted_13, _toDisplayString(_ctx.user.providerData[0].providerId), 1)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})